"use strict";

exports.__esModule = true;
exports["default"] = void 0;
// Basically a copy of 'Teselagen.utils.NameUtils' for use within workers.
var _default = {
  /**
   * Reformat name to replaces whitespace with underscores.
   * @param {string} pName
   * @returns {string} New name.
   */
  reformatName: function reformatName(pName) {
    return pName.toString().replace(/ /g, '_');
  }
};
exports["default"] = _default;
module.exports = exports.default;